interface ArticleHeaderProps {
  title?: string;
  description?: string;
}

export const ArticleHeader = ({ title, description }: ArticleHeaderProps) => (
  <>
    {title && <h1 className="text-4xl font-bold xl:text-5xl">{title}</h1>}
    {description && <p className="mt-6 text-lg text-gray-600 xl:text-xl">{description}</p>}
  </>
);
